import { StyleSheet } from 'react-native';
import FontFamily from '../../../../constants/fonts';

export const styles = StyleSheet.create({
  searchContainer: {
    marginBottom: 12,
  },
  searchInputWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D0D9E8',
    borderRadius: 8,
    paddingHorizontal: 12,
    height: 40,
    maxWidth: 480,
  },
  searchIcon: {
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    fontSize: 14,
    color: '#2D2D2D',
    fontFamily: FontFamily.regular,
    outlineStyle: 'none',
  } as any,
  searchClear: {
    padding: 4,
    marginLeft: 4,
  },
  filterContainer: {
    marginBottom: 8,
  },
  modulesCell: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
  },
  moduleBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  moduleBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    fontFamily: FontFamily.medium,
  },
  locationTypeCell: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
  },
  locationTypeBadge: {
    backgroundColor: '#AAD2E2',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  locationTypeBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#1E5A7A',
    fontFamily: FontFamily.medium,
  },
  orgTypeBadge: {
    backgroundColor: '#DAEEFA',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  orgTypeBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#01346F',
    fontFamily: FontFamily.medium,
  },
});
